import React from "react";
import { ImageContainer, PartImg } from "./PartImageStyles";
import { Part } from "../../reducers/models/parts";

export default function PartImage({ part }: { part: Part }) {
  if (part.image_url === null) {
    return null;
  }

  return (
    <ImageContainer>
      <PartImg src={part.image_url} alt={part.name} />
    </ImageContainer>
  );
}
